export default "__VITE_ASSET__Dfo8NAcO__"